/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
import { AdVehicleStreamServiceCancellationVehicleFragmentDoc } from '../../ServiceCancellation/ServiceCancellation.hook'

const defaultOptions = {} as const
export type AdVehicleModalFooterStartHandlingVehicleMutationVariables =
  Types.Exact<{
    vehicleId: Types.Scalars['ID']['input']
  }>

export type AdVehicleModalFooterStartHandlingVehicleMutation = {
  __typename?: 'Mutation'
  fccStartHandlingVehicle: any | null
}

export type AdVehicleModalFooterVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
      status: Types.FccAdAlertStatus
    }>
  } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    adState: Types.FccWaypointState | null
    stop: {
      __typename?: 'Stop'
      id: string
      names: Partial<Record<'de' | 'en', string>>
      serviceArea: { __typename?: 'ServiceArea'; id: string }
    } | null
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          trip: { __typename?: 'Trip'; id: string } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
          seats: {
            __typename?: 'FccWaypointSeatInfo'
            seats: number
            wheelchairs: number
            childSeats: number
            boosterSeats: number
          }
        }
      | { __typename?: 'FccWaypointHubReturnAction' }
      | {
          __typename: 'FccWaypointPickupAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
          notShownUpAt: string | null
          tripIsCancelled: boolean | null
          trip: { __typename?: 'Trip'; id: string } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
          seats: {
            __typename?: 'FccWaypointSeatInfo'
            seats: number
            wheelchairs: number
            childSeats: number
            boosterSeats: number
          }
        }
      | { __typename?: 'FccWaypointReallocationAction' }
    >
  }> | null
}

export const AdVehicleModalFooterVehicleFragmentDoc = gql`
    fragment AdVehicleModalFooterVehicle on Vehicle {
  ...AdVehicleStreamServiceCancellationVehicle
}
    ${AdVehicleStreamServiceCancellationVehicleFragmentDoc}`
export const AdVehicleModalFooterStartHandlingVehicleDocument = gql`
    mutation AdVehicleModalFooterStartHandlingVehicle($vehicleId: ID!) {
  fccStartHandlingVehicle(vehicleId: $vehicleId)
}
    `
export type AdVehicleModalFooterStartHandlingVehicleMutationFn =
  Apollo.MutationFunction<
    AdVehicleModalFooterStartHandlingVehicleMutation,
    AdVehicleModalFooterStartHandlingVehicleMutationVariables
  >

/**
 * __useAdVehicleModalFooterStartHandlingVehicleMutation__
 *
 * To run a mutation, you first call `useAdVehicleModalFooterStartHandlingVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleModalFooterStartHandlingVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adVehicleModalFooterStartHandlingVehicleMutation, { data, loading, error }] = useAdVehicleModalFooterStartHandlingVehicleMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdVehicleModalFooterStartHandlingVehicleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdVehicleModalFooterStartHandlingVehicleMutation,
    AdVehicleModalFooterStartHandlingVehicleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdVehicleModalFooterStartHandlingVehicleMutation,
    AdVehicleModalFooterStartHandlingVehicleMutationVariables
  >(AdVehicleModalFooterStartHandlingVehicleDocument, options)
}
export type AdVehicleModalFooterStartHandlingVehicleMutationHookResult =
  ReturnType<typeof useAdVehicleModalFooterStartHandlingVehicleMutation>
export type AdVehicleModalFooterStartHandlingVehicleMutationResult =
  Apollo.MutationResult<AdVehicleModalFooterStartHandlingVehicleMutation>
export type AdVehicleModalFooterStartHandlingVehicleMutationOptions =
  Apollo.BaseMutationOptions<
    AdVehicleModalFooterStartHandlingVehicleMutation,
    AdVehicleModalFooterStartHandlingVehicleMutationVariables
  >
